import { Box, Drawer, Grid } from '@material-ui/core';
import { Pricing } from '@nemuru-eng/js-api-client';

import { PricingFormWrapper } from '@/components/modules/PricingCreate/components/PricingFormWrapper';
import { PricingNameFormSchema } from '@/components/modules/PricingEditor/schemas/PricingNameFormSchema';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

import { usePricingEditor } from '../hooks/usePricingEditor';

type PricingNameFormValues = {
  name: string;
  description: string;
};

interface PricingNameFormProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  pricing: Pricing;
  defaultValues?: PricingNameFormValues;
}

export const PricingNameForm = ({ open, setOpen, pricing }: PricingNameFormProps) => {
  const { changePricingName } = usePricingEditor(pricing.id);

  const onSubmit = async (data: PricingNameFormValues) => {
    await changePricingName(data.name, data.description);
    setOpen(false);
  };

  const PricingNameFormDefaultValues = {
    name: pricing.name,
    description: pricing.description,
  };

  return (
    <Drawer anchor={'bottom'} open={open} onClose={() => setOpen(false)}>
      <Box p={6}>
        <Box mb={5}>
          <Font variant={'h3'} color={'title'}>
            <Text tId={'CHANGE_PRICING_NAME'} />
          </Font>
        </Box>
        <PricingFormWrapper
          defaultValues={PricingNameFormDefaultValues}
          formSchema={PricingNameFormSchema}
          onSubmitForm={onSubmit}
        >
          <main style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <section
              style={{
                width: '100%',
                overflowX: 'auto',
                paddingBottom: '16px',
              }}
            >
              <>
                <Grid container>
                  <Grid item xs={12} sm={2} style={{ paddingRight: '16px', paddingBottom: '16px' }}>
                    <TextFormField autoFocus name={'name'} label="name" />
                  </Grid>
                  <Grid item xs={12} sm={10}>
                    <TextFormField name={'description'} label={'description'} />
                  </Grid>
                </Grid>
              </>
            </section>
          </main>
        </PricingFormWrapper>
      </Box>
    </Drawer>
  );
};
